import axios from 'axios';
import { storeAction } from '../storeActions.constant';
import { storeGetters } from '../storeGetters.constant';
import { storeMutation } from '../storeMutations.constant';
import { getBasicHeaders } from '../../common/utils/utils';
import { wrapAction } from '../../common/utils/actionLifecycle';
import { remove } from 'lodash/remove';
import FileSaver from 'file-saver';

const assistPageState = () => {
    return {
        topics: [],
        TakeATourVideos: [],
        NewsAndComingSoonFiles: [],
        BASE_URL: process.env.VUE_APP_BASE_URL,
        recentReleasesFiles: null,
        comingSoonFiles: null,
        canEdit: false,
        CanUserEdit: false,
        UploadNewComingSoonStatus: false,
        canEditTakeTourVideos: false,
        fileUploadPercentage: 0,
        videoUploadPercentage: 0,
        releaseNotes: {},
    };
};

const assistPageMutations = {
    [storeMutation.setTopicsForAssistPage]: (state, data) => {
        if (data.length !== 0) {
            data.topics.forEach((topic) => {
                topic.isEditTopic = false;
                topic.newQuestion = '';
                topic.newAnswer = '';
                topic.hasNewQuestion = false;

                topic.questionAnswers.forEach((item) => {
                    item.isEditQuestion = false;
                    item.isEditAnswer = false;
                    item.isLastQuestion = false;
                });
            });
        }
        state.topics = data.topics;
        state.canEdit = data.canEdit;
    },
    [storeMutation.setTakeTourVideos]: (state, data) => {
        state.TakeATourVideos = data.assistVideos;
        state.canEditTakeTourVideos = data.canEdit;
        state.TakeATourVideos.forEach((item) => {
            item.isNewRow = false;
            item.isDeleteRow = false;
            item.isEditRow = false;
            item.downloadInProgress = false;
            if (item.fileExt && (item.fileExt !== '' || item.fileExt !== ' ')) {
                item.title = item.title.concat(`.${item.fileExt}`);
            } else {
                item.title = item.title;
            }
        });
    },
    [storeMutation.setNewsAndComingSoonFiles]: (state, data) => {
        state.NewsAndComingSoonFiles = data.releaseMedia;
        state.canEdit = data.canEdit;
    },
    [storeMutation.setUploadNewComingSoonStatus]: (state, data) => {
        state.UploadNewComingSoonStatus = data;
    },
    [storeMutation.setCanUserEdit]: (state, data) => {
        state.CanUserEdit = data;
    },
    [storeMutation.setUploadedVideoList]: (state, data) => {
        state.TakeATourVideos.push(data);
    },
    [storeMutation.setTourVideoTitle]: (state, data) => {
        state.TakeATourVideos.find(video => video.id === data.id).title = data.title;
    },
    [storeMutation.setDeletedTakeTourVideo]: (state, data) => {
        remove(state.TakeATourVideos, (list) => {
            return list.id === data;
        });
        state.TakeATourVideos = [...state.TakeATourVideos];
    },
    [storeMutation.setReleaseNotes]: (state, data) => {
        if (data && data.releaseNote && data.releaseNote.length > 0) {
            [state.releaseNotes] = data.releaseNote;
            state.canEdit = data.canEdit;
        }
    },
};

const assistPageActions = {
    [storeAction.getAssistPageTopics]: wrapAction(storeAction.getAssistPageTopics, ({ state, commit }) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/get-topic-articles`,
            //url: '/mocks/MakeConnectForYou.json',
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setTopicsForAssistPage, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getTakeTourVideos]: wrapAction(storeAction.getTakeTourVideos, ({ state, commit }) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/list-tour-section-videos`,
            //url: '/mocks/TakeATour.json',
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setTakeTourVideos, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getNewsAndComingSoonFiles]: wrapAction(storeAction.getNewsAndComingSoonFiles, ({ state, commit }) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/get-release-media`,
            //url: '/mocks/NewsAndComingSoon.json',
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setNewsAndComingSoonFiles, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.isAdminUser]: wrapAction(storeAction.isAdminUser, ({ state, commit }) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/is-admin-user`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                console.log(response);
                commit(storeMutation.setCanUserEdit, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.updateNewAndComingSoonFile]: wrapAction(
        storeAction.updateNewAndComingSoonFile,
        ({ state, commit }, fileData) => {
            return axios({
                url: `${state.BASE_URL}assistpage/api/assist/update-new-comingsoon-file/${fileData.fileType}`,
                headers: getBasicHeaders(),
                'Content-Type': 'multipart/form-data',
                data: fileData.selectedFile,
                method: 'POST',
                onUploadProgress: (progressEvent) => {
                    const val = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total), 10);
                    state.fileUploadPercentage = val > 10 ? val - 10 : val;
                },
            })
                .then((response) => {
                    state.fileUploadPercentage = 0;
                    console.log(response);
                    commit(storeMutation.setUploadNewComingSoonStatus, response.data);
                })
                .catch((err) => {
                    console.log(err);
                    state.fileUploadPercentage = 0;
                    throw err;
                });
        },
    ),
    [storeAction.uploadFiles]: async ({ state }, formData) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/create-tour-video`,
            headers: getBasicHeaders(),
            data: formData,
            'Content-Type': 'multipart/form-data',
            method: 'POST',
            onUploadProgress: (progressEvent) => {
                const val = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total), 10);
                state.videoUploadPercentage = val > 10 ? val - 10 : val;
            },
        })
            .then((response) => {
                state.videoUploadPercentage = 0;
                console.log(response);
                //commit(storeMutation.setUploadNewComingSoonStatus, response.data);
            })
            .catch((err) => {
                console.log(err);
                state.videoUploadPercentage = 0;
                throw err;
            });
    },

    [storeAction.createTopics]: ({ state }, objectToSave) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/create-topic-articles`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },

    [storeAction.createQuestion]: ({ state }, objectToSave) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/create-article`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'POST',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.saveTopic]: ({ state }, objectToSave) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/update-make-connect-Topic`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'PUT',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.saveQuestion]: ({ state }, objectToSave) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/update-make-connect-question`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'PUT',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.saveAnswer]: ({ state }, objectToSave) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/update-make-connect-answer`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'PUT',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.saveAssistOrder]: ({ state }, assistPageTopicList) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/reorder-topic-articles`,
                headers: getBasicHeaders(),
                data: assistPageTopicList,
                method: 'POST',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.deleteTopic]: ({ state }, topicId) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/delete-make-connect-topic/${topicId}`,
                headers: getBasicHeaders(),
                method: 'DELETE',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.deleteArticle]: ({ state }, articleId) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/delete-make-connect-article/${articleId}`,
                headers: getBasicHeaders(),
                method: 'DELETE',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.saveTourReorderList]: async ({ state }, list) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/reorder-tourvideos`,
                headers: getBasicHeaders(),
                data: list,
                method: 'POST',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
    [storeAction.updateTakeTourVideoTitle]: wrapAction(
        storeAction.updateTakeTourVideoTitle,
        ({ state, commit }, tourVideoData) => {
            return axios({
                url: `${state.BASE_URL}assistpage/api/assist/update-tour-video`,
                //url: '/mocks/TakeATour.json',
                headers: getBasicHeaders(),
                data: tourVideoData,
                method: 'PUT',
            })
                .then((response) => {
                    commit(storeMutation.setTourVideoTitle, response.data);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        },
    ),
    [storeAction.deleteTakeTourVideo]: wrapAction(storeAction.deleteTakeTourVideo, ({ state, commit }, tourVideoId) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/delete-tour-video/${tourVideoId}`,
            headers: getBasicHeaders(),
            method: 'DELETE',
        })
            .then((response) => {
                if (response.data) {
                    commit(storeMutation.setDeletedTakeTourVideo, tourVideoId);
                }
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.downloadTakeTourVideo]: wrapAction(storeAction.downloadTakeTourVideo, ({ state }, tourVideo) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/download-tour-video/${tourVideo.id}`,
            headers: getBasicHeaders(),
            method: 'POST',
            responseType: 'arraybuffer',
        })
            .then((response) => {
                const blob = new Blob([response.data], { type: 'octet/stream' });
                FileSaver.saveAs(blob, `${tourVideo.title}`);
                return response;
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.getReleaseNotes]: wrapAction(storeAction.getReleaseNotes, ({ state, commit }) => {
        return axios({
            url: `${state.BASE_URL}assistpage/api/assist/get-release-notes`,
            headers: getBasicHeaders(),
            method: 'GET',
        })
            .then((response) => {
                commit(storeMutation.setReleaseNotes, response.data);
            })
            .catch((err) => {
                console.log(err);
                throw err;
            });
    }),
    [storeAction.updateReleaseNotes]: ({ state }, objectToSave) => {
        return new Promise((resolve) => {
            axios({
                url: `${state.BASE_URL}assistpage/api/assist/update-release-notes`,
                headers: getBasicHeaders(),
                data: { ...objectToSave },
                method: 'PUT',
            })
                .then((response) => {
                    resolve(response);
                })
                .catch((err) => {
                    console.log(err);
                    throw err;
                });
        });
    },
};

const assistPageGetters = {
    [storeGetters.canEditAssistPage]: state => state.canEdit,
    [storeGetters.assistPageTopics]: state => state.topics,
    [storeGetters.takeTourVideos]: state => state.TakeATourVideos,
    [storeGetters.newsAndComingSoonFiles]: state => state.NewsAndComingSoonFiles,
    [storeGetters.canAssistUserEdit]: state => state.CanUserEdit,
    [storeGetters.newAndComingSoonUploadStatus]: state => state.UploadNewComingSoonStatus,
    [storeGetters.canEditTakeTourVideos]: state => state.canEditTakeTourVideos,
    [storeGetters.fileUploadPercentage]: state => state.fileUploadPercentage,
    [storeGetters.videoUploadPercentage]: state => state.videoUploadPercentage,
    [storeGetters.releaseNotes]: state => state.releaseNotes,
};

export default {
    namespaced: true,
    state: {
        initialState: assistPageState(),
        ...assistPageState(),
    },
    mutations: { ...assistPageMutations },
    actions: { ...assistPageActions },
    getters: { ...assistPageGetters },
};
